import application from 'application/application';

import template from './plans.template.html';

import controller from './plans.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.account.plans', {
				url: '/planos',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Planos'
				}
			});

	}]);
